import React, { createContext, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

const ModuleContext = createContext({
  modules: [],
  isModuleEnabled: () => true,
  loading: false,
});

export const ModuleProvider = ({ children }) => {
  const enabledModules = useSelector((state) => state.globalState?.enabled_modules);

  const value = useMemo(() => {
    // Deny until loaded. Previously an unloaded state fell back to the domain's
    // default module list — which grants every module on an unrecognised host —
    // so features a school has not been given could appear for the window
    // between mount and the permissions API responding.
    //
    // Now nothing is enabled until the backend has actually answered. Consumers
    // should render a loading state off `loading` rather than treating the empty
    // list as "this school has no modules".
    const loaded = Array.isArray(enabledModules);
    const modules = loaded ? enabledModules : [];
    const moduleSet = new Set(modules);

    return {
      modules,
      isModuleEnabled: (key) => loaded && moduleSet.has(key),
      loading: !loaded,
    };
  }, [enabledModules]);

  return (
    <ModuleContext.Provider value={value}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleContext = () => useContext(ModuleContext);

export default ModuleContext;
